import React, { useState } from "react";
import { Aside, ListActionButtonProps } from "sprint-common-web";

import { EditListButton } from "../../../../../common/components/buttons/EditListButton";
import { LanguageCodeMappingItem } from "../../LanguageSpecificationDashboardItem";
import { EditMappingForm } from "./EditMappingForm";

export const EditLanguageCodeMappingButton: React.FC<ListActionButtonProps<LanguageCodeMappingItem>> = (
    props: ListActionButtonProps<LanguageCodeMappingItem>
) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

    const openSidebar = () => {
        setIsSidebarOpen(true);
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const handleFormSubmit = () => {
        closeSidebar();
    };

    return (
        <>
            <EditListButton onClick={openSidebar} />
            <Aside isOpen={isSidebarOpen} type="form" headerText="Edit" onDismiss={closeSidebar}>
                <EditMappingForm
                    onCancel={closeSidebar}
                    onSubmit={handleFormSubmit}
                    languageId={props.item.languageId}
                />
            </Aside>
        </>
    );
};
